import { render, staticRenderFns } from "./ManageProvider.vue?vue&type=template&id=2ff9dd8a&scoped=true"
import script from "./ManageProvider.vue?vue&type=script&lang=js"
export * from "./ManageProvider.vue?vue&type=script&lang=js"
import style0 from "./ManageProvider.vue?vue&type=style&index=0&id=2ff9dd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9dd8a",
  null
  
)

export default component.exports